import { handleActions } from 'redux-actions'
import { setCommunicationPreferencesEditMode } from './actions'

export default handleActions({
  [setCommunicationPreferencesEditMode]: (state, { payload }) => ({ editMode: payload })
}, { editMode: false })
